export const CHECK_PERIOD = 2000;
let timerId;
export const metrics = {
    routingStart: undefined,
    lastDomMutation: undefined,
};
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutationHandler);
});
const observerConfig = {
    subtree: true,
    childList: true,
    attributes: true,
    characterData: true,
};
export function initLoadTimeTracking() {
    trackRouteChange();
}
export function mutationHandler() {
    metrics.lastDomMutation = performance.now();
    performance.mark('last-dom-mutation');
}
function trackRouteChange() {
    window.addEventListener('hashchange', handleRouteChange);
    window.addEventListener('popstate', handleRouteChange);
}
export function handleRouteChange() {
    metrics.routingStart = performance.now();
    performance.mark('route-change');
    observeDomMutations();
}
export function observeDomMutations() {
    cleanUp();
    observer.observe(document.body, observerConfig);
    timerId = setInterval(checkPageForLoad, CHECK_PERIOD);
}
export function checkPageForLoad() {
    if (hasNoMutationsOnLastIteration(metrics === null || metrics === void 0 ? void 0 : metrics.lastDomMutation)) {
        if ((metrics === null || metrics === void 0 ? void 0 : metrics.lastDomMutation) && (metrics === null || metrics === void 0 ? void 0 : metrics.routingStart)) {
            const loadingTime = metrics.lastDomMutation - metrics.routingStart;
            performance.measure('loading-time', 'route-change', 'last-dom-mutation');
            sendMetricToDatadog('onvio.load_time', loadingTime);
        }
        cleanUp();
    }
}
export function hasNoMutationsOnLastIteration(lastDomMutationTime) {
    if (lastDomMutationTime) {
        return performance.now() - lastDomMutationTime > CHECK_PERIOD;
    }
    return false;
}
export function sendMetricToDatadog(name, value) {
    try {
        const dd = window.DD_RUM;
        dd.addAction(name, {
            type: 'metric',
            value,
            view: {
                url: window.location.href,
            },
        });
    }
    catch (e) {
        console.error(e);
    }
}
export function cleanUp() {
    observer.disconnect();
    clearInterval(timerId);
}
